module.exports = __webpack_public_path__ + "img/background-study-investor.ce1bdb27.jpg";